import { type RouteRecordRaw } from 'vue-router'

export const SwaggerRouter: RouteRecordRaw[] = [
  {
    path: '/swagger',
    component: async () => import('./Swagger.vue'),
  },
]
